import { Box, Group, Stack, Text, Tooltip } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { FeatureUsage } from '@/types/subscription'
import { formatSize } from '@/utils/file'
import { UsageProgressBar } from '../UsageProgressBar/UsageProgressBar'
import { isUsageNearLimit } from '../usageUtils'

type DataUsageIndicatorProps = {
  title?: ReactNode
  tooltip?: ReactNode
  used: number
  total: number
  unit: FeatureUsage['unit']
  isMonthly?: boolean
}

export const DataUsageIndicator = ({
  title,
  tooltip,
  used,
  total,
  unit,
  isMonthly
}: DataUsageIndicatorProps) => {
  if (unit === 'count') {
    return null
  }

  return (
    <Stack gap={2}>
      {title && (
        <Group wrap="nowrap" gap={4}>
          <Text size="xs" fw={600}>
            {title}
          </Text>

          {tooltip && (
            <Tooltip label={tooltip} w={320} multiline>
              <IconInfoCircle size={14} />
            </Tooltip>
          )}
        </Group>
      )}

      <Box>
        <Group gap="xs" align="center">
          <UsageProgressBar
            size="md"
            flex={1}
            isFull={isUsageNearLimit(used, total)}
            value={total > 0 ? (used / total) * 100 : 0}
          />

          <Text fz={11} fw={600}>
            {formatSize(total, unit, false)}
          </Text>
        </Group>

        <Text fz={11}>
          <FormattedMessage
            id="subscriptions.usage.withoutTotal"
            values={{
              count: formatSize(used > total ? total : used, unit, false)
            }}
          />
          {isMonthly && (
            <>
              {' '}
              <FormattedMessage id="subscriptions.usage.thisMonth" />
            </>
          )}
        </Text>
      </Box>
    </Stack>
  )
}
